import { useColorMode } from '@chakra-ui/react'
import { useEffect } from 'react'

export const useForceColorMode = () => {
  const { setColorMode } = useColorMode()
  useEffect(() => {
    setColorMode('light')
  }, [setColorMode])
}
